import { useState } from 'react';
import { Html, useCursor } from '@react-three/drei';
import { RigidBody } from '@react-three/rapier';

interface InteractiveBoardProps {
    position: [number, number, number];
    rotation?: [number, number, number];
    title: string;
    description: string;
}

export const InteractiveBoard = ({ position, rotation = [0, 0, 0], title, description }: InteractiveBoardProps) => {
    const [hovered, setHovered] = useState(false);
    const [active, setActive] = useState(false);
    useCursor(hovered);

    return (
        <group position={position} rotation={rotation}>
            <RigidBody type="fixed" colliders="hull">
                {/* Post */}
                <mesh position={[0, 1, 0]} castShadow receiveShadow>
                    <boxGeometry args={[0.2, 2, 0.2]} />
                    <meshStandardMaterial color="#5d4037" roughness={0.9} />
                </mesh>

                {/* Board */}
                <mesh
                    position={[0, 1.8, 0.1]}
                    castShadow
                    receiveShadow
                    onPointerOver={() => setHovered(true)}
                    onPointerOut={() => setHovered(false)}
                    onClick={() => setActive(!active)}
                >
                    <boxGeometry args={[1.5, 1, 0.1]} />
                    <meshStandardMaterial color="#8d6e63" roughness={0.8} />
                </mesh>
            </RigidBody>

            {/* UI Overlay */}
            <Html
                position={[0, 2.5, 0]}
                center
                distanceFactor={10}
                style={{
                    background: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '10px',
                    borderRadius: '5px',
                    width: '200px',
                    textAlign: 'center',
                    pointerEvents: 'none',
                    opacity: active || hovered ? 1 : 0,
                    transition: 'opacity 0.2s',
                    transform: 'translate3d(-50%, -50%, 0)',
                    fontFamily: 'Arial, sans-serif'
                }}
            >
                <h3 style={{ margin: '0 0 5px 0', fontSize: '1.2em', color: '#ffd700' }}>{title}</h3>
                {active && <p style={{ margin: 0, fontSize: '0.9em' }}>{description}</p>}
                {!active && <p style={{ margin: 0, fontSize: '0.7em', color: '#aaa', fontStyle: 'italic' }}>(Click to read)</p>}
            </Html>
        </group>
    );
};
